<template>
  <div data-toggle="tooltip"
        data-delay='{"show":"800", "hide":"100"}'
        :title="'title'">
    <slot></slot>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  params: ['title'],
  mounted() {
    // enable bootstrap tooltip
    $(() => {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },
};
</script>

<style>
  .tooltip.top .tooltip-inner {
    background-color: #eee;
    color: #233d53;
    width: 160px;
    border-radius: 0;
    padding: 7px;
  }
  .tooltip.top .tooltip-arrow {
    border-top-color: #eee;
    display: none;
  }
</style>



// WEBPACK FOOTER //
// Tooltip.vue?e66c6a62